<app-page-header
    title="Historial de cambios de flujos"
    mobileTitle="Historial flujos"
    icon="fas fa-history"
    [showBack]="true"
    [hasOptions]="false"
    (back)="closeModule()">
</app-page-header>

<div class="row">
    <div class="col-12"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()">
            <div class="mobile-list-shell" [class.panel-body]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
                <app-flow-audit-list />
            </div>
        </div>
    </div>
</div>
